// assets/hbk-region-popup.js
(function () {
  'use strict';

  var STORAGE_KEY = 'hbk-region-chosen';
  var instances = new Map();

  function hasChosen() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return true; }
  }
  function remember() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  function focusable(el) {
    return Array.from(
      el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
  }

  function Region(el) {
    this.el = el;
    this.dialog = el.querySelector('.hbk-region__dialog');
    this.design = el.dataset.designMode === 'true';
    this.prevFocus = null;
    this._onKey = this._onKey.bind(this);

    // Dismiss triggers (overlay, close button, "later" link).
    el.querySelectorAll('[data-region-dismiss]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        this.close();
        remember();
      }.bind(this));
    }.bind(this));

    // Choosing (form submit) also counts as chosen — the page then reloads localized.
    var form = el.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        remember();
        // If ONLY the language changed (country unchanged), navigate straight to that
        // language's localized URL. This GET is far more reliable than the POST
        // /localization form (which can silently no-op in an unpublished theme preview),
        // and matches the header language switch. When the country also changes we let
        // the form POST proceed so both locale_code + country_code are applied together.
        var lang = form.querySelector('input[name="locale_code"]:checked');
        var countrySel = form.querySelector('select[name="country_code"]');
        var langChanged = lang && lang.value !== el.dataset.currentLocale;
        var countryChanged = countrySel && countrySel.value !== el.dataset.currentCountry;
        if (langChanged && !countryChanged && lang.getAttribute('data-lang-url')) {
          e.preventDefault();
          window.location.href = lang.getAttribute('data-lang-url');
        }
      });
    }

    // In the Theme Editor: always show it so the merchant can style it (don't remember).
    if (this.design) { this.open(); return; }
    if (!hasChosen()) {
      // Defer to the next frame so the entrance transition runs.
      requestAnimationFrame(function () { requestAnimationFrame(this.open.bind(this)); }.bind(this));
    }
  }

  Region.prototype.open = function () {
    if (this.el.classList.contains('is-open')) return;
    this.prevFocus = document.activeElement;
    this.el.classList.add('is-open');
    this.el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._onKey);
    var f = focusable(this.dialog);
    if (f.length) setTimeout(function () { f[0].focus(); }, 60);
  };

  Region.prototype.close = function () {
    if (!this.el.classList.contains('is-open')) return;
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._onKey);
    if (this.prevFocus && this.prevFocus.focus) this.prevFocus.focus();
  };

  Region.prototype._onKey = function (e) {
    if (e.key === 'Escape') {
      this.close();
      remember();
      return;
    }
    if (e.key === 'Tab') {
      var f = focusable(this.dialog);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-component="region-popup"]').forEach(function (el) {
      if (instances.has(el)) return;
      instances.set(el, new Region(el));
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-component="region-popup"]').forEach(function (el) {
      var inst = instances.get(el);
      if (inst) { inst.close(); instances.delete(el); }
    });
  });
})();
